export { assemble as default, assemble as compose } from "./assemble";

//# sourceMappingURL=compose.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/compose.js
// module id = 50
// module chunks = 0